/**
 * @Description 组件 项目管理
 * @Author 
 * @Date 
 */
/* HTML */
<template>
	<div style="height: calc(100% - 54px);width: 100%;position: relative;background-color: rgba(3,11,24,0.87);border: 2px solid #234582;">
		
		<!-- 加载中 -->
		<div :class="{'none-map-item': true, 'off': flags.falg_AMap_inited}" >
 			<img alt="加载中" v-show="!flags.falg_AMap_inited" title="加载中" src="@/static_dazzle/images/loading_1.gif" >
 		</div>
		
		<!-- 地图 容器 -->
		<div id="mapItem_org" class="view-amap-box" @contextmenu.prevent="onContextmenu" style="height: 100%;width: 100%;text-align: left;"></div>
		
		<!-- 条件查询 start -->
		<el-form :inline="true" :model="filters" ref="filters" class="form-out-map" v-show="flags.falg_AMap_inited">
			<el-form-item prop="" style="margin-right: 10px;">
				<el-button v-if="!flags.flag_row_add && !this.flags.flag_row_edit" icon="el-icon-circle-plus-outline" @click="addRow" style="vertical-align: top;">新增项目</el-button>
				<span v-if="flags.flag_row_add || flags.flag_row_edit" style="margin: 0 5px;padding: 0 5px;line-height: 30px;background-color: #034178;height: 30px;display: inline-block;vertical-align: top;">点击地图选取项目位置</span>
				<el-button v-if="(flags.flag_row_add || flags.flag_row_edit) && (lnglat.lng && lnglat.lat)" icon="el-icon-check" @click="completePoint" style="vertical-align: top;">完成坐标选取</el-button>
				<el-button v-if="flags.flag_row_add || flags.flag_row_edit" icon="el-icon-close" @click="cancel" style="vertical-align: top;">取消</el-button>
			</el-form-item>
			<el-form-item prop="address">
				<el-input id="addressInp" style="width: 240px;" v-model="filters.address" placeholder="请输入目的地名称" clearable @keyup.enter.native="handleSearch" @clear="handleSearch">
					<el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
				</el-input>
			</el-form-item>
			<el-form-item v-show="false" prop="">
				<el-input style="width: 240px;" v-model="filters.address" placeholder="请输入目的地名称" clearable>
					<el-button slot="append" icon="el-icon-search" ></el-button>
				</el-input>
			</el-form-item>
		</el-form>
		<!-- 条件查询 end -->
		
		<div :class="{'aside-button-box': true, 'b-0': !showAsideFlag, 'b-30': showAsideFlag}" style="text-align: end" >
            <el-tooltip v-if="true"
                        :content="showAsideFlag ? '关闭数据列表' : '开启数据列表'"
                        placement="top" >
                <el-button
                    class="aside-button"
                    style="z-index: 9999;position: relative;border-image: none;"
                    :type="showAsideFlag ? 'success' : 'info'"
                    :icon="showAsideFlag ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
                    @click="changeAsideFlag"
                    round />
                <!--</el-badge>-->
            </el-tooltip>
        </div>

        <!-- 设备表展示myAside -->
        <el-aside v-if="showAsideFlag"
                  id="realtimeLocationMyAsideTable"
                  style="position: absolute;bottom: 0; height: 40%;font-size: 5px;z-index: 1000;width: 100%;overflow-y: auto;" >
            <u-table
                ref="realtimeLocationFilterTable"
                fixed-columns-roll
                beautify-table
                header-drag-style
                show-body-overflow="tooltip"
                highlight-current-row
                :data="rows"
                size="mini"
                use-virtual
                style="height: calc(100% - 40px);"
                row-id="projectId"
                @row-click="handleRowClick"
                border >
                <u-table-column
                    type="index"
                    :resizable=false
                    align="center"
                    header-align="center"
                    label="序号"
                    width="80px"
                    :border-line=false />
                <u-table-column
                    :resizable=false
                    align="center"
                    header-align="center"
                    :tree-node="true"
                    prop="projectName"
                    label="项目名称"
                    min-width="180px"
                    :border-line=false>
                    <!--<template slot-scope="scope" >
                        {{scope.row.projectName}}
                    </template>-->
                </u-table-column>
                <u-table-column
                    :resizable=false
                    align="center"
                    header-align="center"
                    :tree-node="true"
                    prop="coordinate"
                    label="坐标系"
                    min-width="100px"
                    :border-line=false>
                    <template slot-scope="scope" >
                        {{coordinateTypes[scope.row.coordinate]}}
                    </template>
                </u-table-column>
                <u-table-column
                    :resizable=false
                    align="center"
                    header-align="center"
                    :tree-node="true"
                    prop="lnglat"
                    label="中心坐标"
                    min-width="200px"
                    :border-line=false>
                    <template slot-scope="scope" >
                        {{scope.row.centerLng + "," + scope.row.centerLat}}
                    </template>
                </u-table-column>
                <u-table-column
                    :resizable=false
                    align="center"
                    header-align="center"
                    :tree-node="true"
                    prop="createTime"
                    label="创建时间"
                    min-width="200px"
                    :border-line=false>
                    <template slot-scope="scope" >
                        {{$moment(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss')}}
                    </template>
                </u-table-column>
                <u-table-column
                    :resizable=false
                    align="center"
                    header-align="center"
                    :tree-node="true"
                    prop="website"
                    min-width="200px"
                    label="地址"
                    :border-line=false />
                <u-table-column
                    :resizable=false
                    align="center"
                    header-align="center"
                    :tree-node="true"
                    label="操作"
                    min-width="200px"
                    :border-line=false>
                    <template slot-scope="scope">
                    	<div style="text-align: left;">
                    		<!-- 编辑 -->
							<el-button icon="el-icon-edit" size="mini" type="primary" @click="updateRow(scope.row)" style="padding: 7px 5px;">编辑</el-button >
	                    	<!-- 删除 -->
							<el-button icon="el-icon-delete" size="mini" type="danger" @click="deleteRow(scope.row)" style="padding: 7px 5px;">删除</el-button >
	                        <!-- 访问本地 -->
							<el-button v-if="!$checkEmpty(scope.row.website)" icon="el-icon-link" size="mini" type="primary" @click="gotoLocation(scope.row)" style="padding: 7px 5px;">访问本地</el-button >
                    	</div>
                    </template>
                </u-table-column>
            </u-table>
            <div style="padding-top: 5px;background-color: #070F1F;">
	            <!--分页工具条-->
				<Pagination :currentPage="pagination.currentPage" :total="pagination.total" :pageSize="pagination.limit" @handleSizeChangeSub="handleSizeChangeSub" @handleCurrentChangeSub="handleCurrentChangeSub" />
            </div>
        </el-aside>
		<!-- 设备表展示myAside end -->
		
		<!-- 弹窗 项目 -->
		<OrgDialog ref="OrgDialog" :lnglat="lnglat" @setTotal="setTotal" @setRow="setRow" @search="searchProjects" @cancel="cancel" />
		
	</div>
</template>

/* JS */
<script>
	// 公共方法
	import GlobalFun from '@/global/global-function';
	// 公共变量
	import GlobalVar from '@/global/global-variable';
	// 公共 参数
	import GlobalParam from "@/global/global-param";
	// API 项目管理
	import ApiOrgGnss from '@/request/api-org_gnss';
	// 组件 谷歌地图
	import {mapGPSGaode} from '@/static_dazzle/plugins/amap/map_gps_gaode';
	// 组件 弹窗 项目表单
	import OrgDialog from './OrgDialog';
	// 组件 分页
	import Pagination from '@/components/Pagination';
	
	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
        name: "OrgModule",
        
        /**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
        components: {
        	// 组件 弹窗 项目表单
        	OrgDialog,
        	// 组件 分页
        	Pagination,
        },// components
        
        /**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
        props: {
        	
        },// props
        
        /**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				// 地图 组件
				mapFn: new mapGPSGaode(),
				// 地理位置 自动搜索
				autocomplete: null,
				
				// key list
				keys: [],
				// 数据 list
				rows: [],
				
				// 显示/隐藏 右侧列表
				showAsideFlag: false,
				// 关键字
				keywords: '',
				// 坐标系类型
				coordinateTypes: GlobalParam.coordinateTypes,
				
				/**
				 * @Des 分页数据
				 * @Auth
				 * @Date 
				 */
				pagination: {
					total: 0,
					startNum: 0,
					limit: 20,
					currentPage: 1
				},// pagination
				
				// 参数
				filters: {
					// 地址
					address: '' ,
				},
				
				// flags
				flags: {
					falg_subscribes: false,// flag 监听广播
					falg_AMap_inited: false,// flag AMap 已加载
					flag_row_add: false,// flag 新增
					flag_row_edit: false,// flag 编辑
				},// flags
				
				// 室内地图 组织结构
				organizations: [],
				// 经纬度
				lnglat: {lat: '', lng: ''},
				
				// 模拟坐标
				infos: [
					{did: '8801100100010001', lngGc: 116.312043, latGc: 39.983309},
					{did: '8801100100010002', lngGc: 116.312243, latGc: 39.983309},
					{did: '8801100100010003', lngGc: 116.312643, latGc: 39.983309},
					{did: '8801100100010004', lngGc: 116.312843, latGc: 39.983309},
					{did: '8801100100010005', lngGc: 116.313043, latGc: 39.983309},
					
					{did: '8801100100010006', lngGc: 116.314043, latGc: 39.983309},
					{did: '8801100100010007', lngGc: 116.316243, latGc: 39.984309},
					{did: '8801100100010008', lngGc: 116.318643, latGc: 39.985309},
					{did: '8801100100010009', lngGc: 116.310843, latGc: 39.986309},
					{did: '8801100100010010', lngGc: 116.323043, latGc: 39.987309},
					{did: '8801100100010011', lngGc: 116.423043, latGc: 39.987309},
				],
				// 溢出项 个数
				overIndex: 0,
				
			}// return
		},// data
		
		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			
		},// created
		
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			window.goToHere = this.goToHere;
			window.updateRow = this.updateRow;
			window.deleteRow = this.deleteRow;
			window.gotoLocation = this.gotoLocation;
			
			// 初始化 地图
			this.initMap();
			
			// 查询 项目
			this.searchProjects();
			
		},// mounted
				
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			window.goToHere = null;
			window.updateRow = null;
			window.deleteRow = null;
			window.gotoLocation = null;
			
			// 销毁地图
        	this.mapFn.destroyMap();
			
		},// beforeDestroy
		
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {
			
		},// destroyed
		
		/** 缓存组件生命周期 */
		activated() {
			
		},
		deactivated() {
			
		},
		
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			/**
			 * @Des 右击
			 * @Auth
			 * @Date
			 */
			onContextmenu(e) {
				/** 右键菜单 */
				// this.mapFn.onContextmenu(this, e);
			},
			
			/**
			 * @Des 初始化 地图
			 * @Auth
			 * @Date
			 */
			async initMap() {
				// 地图 组件
				await this.mapFn.initMap('mapItem_org', {
					// 地图类型
					mapStyle: 'amap://styles/blue',
				}, (AMap) => {
					// flag AMap 已加载
					this.flags.falg_AMap_inited = true;
					
					// 初始化 地图附属
					this.initMapLayers();
					// 初始化 点聚合
					this.initMarkerCluster();
				});
			},// initMap
			
			/**
			 * @Des 初始化 地图附属
			 * @Auth
			 * @Date
			 */
			initMapLayers() {
				
				// 设置 中心 级别
				// this.mapFn.setZoomAndCenter(13, [124.31671, 40.01149]);
				
				// 添加 自定义地图
				// this.addImageLayer();
				
				// 初始化 自动搜索
				// 地理位置 自动搜索
				this.autocomplete = new this.mapFn.initAutocomplete({input: 'addressInp'});
			},// initMapLayers
			
			/**
			 * @Des 添加 自定义地图
			 * @Auth
			 * @Date
			 */
			addImageLayer() {
				// 创建 覆盖物 image
				this.mapFn.creatImageLayer({
					name:'智慧工厂',
					url: '/static/images/map/mapLayers/jg-gongdi-001.png', // 修改为你自己的图片链接
					bounds: [
						[117.261354,36.751667], // 图片左下角经纬度坐标
						[117.263744,36.750307] // 图片右上角经纬度坐标，可以根据图片大小调整坐标值
					],
					zIndex: 20, // 设置覆盖物的层级
					opacity: 1 ,// 设置覆盖物的透明度
				});// creatImageLayer
			},// addImageLayer
			
			/**
			 * @Des 添加 旗帜
			 * @Auth
			 * @Date
			 */
			// 添加 旗帜
			addFlagMarkers() {
				// 项目
				let projectRow = Object.assign({}, this.organizations[0]);
				// 空值 中止
				if (this.$checkEmpty(projectRow)) return false;
				
				// 区域
				let areaRows = Object.assign([], projectRow.children);
				Object.assign([], areaRows).forEach((row, index) => {
					// 非区域 跳过
					if (row.level != 2) return true;
					let areaNode = Object.assign({}, row.node);
					// 空值 跳过
					if (this.$checkEmpty(areaNode)) return true;
					
					// Icon 旗帜
					let flagIcon = this.mapFn.creatIcon({
						size: [60, 60],
						imageSize: [60, 60],
						icon: '/static/images/map/outdoorIocns/iocn-flag.webp'
					});
					
					let flagDid = ['flagMarker', areaNode.areaId].join('_');
					// Marker 旗帜
					let flagMarker = this.mapFn.creatMarker({
						position: [areaNode.startPointX, areaNode.startPointY],// [117.263698, 36.750353] // 红旗所在的经纬度坐标
						offset: [28, -32], // 将红旗位置上移一些，使其正好位于覆盖物左上角
						icon: flagIcon,
						extData: {"markerID": flagDid, "markerItem": Object.assign({}, row, {did: flagDid})},
						zIndex: 30, // 设置比覆盖物更高的层级
						clickMarker: this.clickFlagMarker,
						// rightClickMarker: this.rightClickFlag
					});
					// 将标记对象添加到地图上
					this.mapFn.addMarker(flagDid, flagMarker);
					
				});
			},// addFlagMarkers
			/**
			 * @Des 点击 旗帜
			 * @Auth
			 * @Date
			 */
			clickFlagMarker(e) {
				return false;
				e = e || event;
				let extData = e.target.getExtData();
				
				let markerItem = Object.assign({}, extData.markerItem);
				let areaRow = Object.assign({}, markerItem.node);
				// 空值 中止
				if (this.$checkEmpty(areaRow) || this.$checkEmpty(markerItem.children)) return false;
				
				// 地图
				let mapRows = Object.assign([], markerItem.children);
				let mapRow = {};
				mapRows.forEach((row, index) => {
					// 已有值 跳过
					if (!this.$checkEmpty(mapRow)) return true;
					// 空值 跳过
					if (this.$checkEmpty(row) || this.$checkEmpty(row.node)) return true;
					mapRows = Object.assign({}, row.node);
				});
				
				// 路由 跳转
				this.$router.replace({path: '/manager/location/monitor', query: {areaId: areaRow.areaId,mapId: mapRow.mapId}}, ()=>{}, ()=>{});
			},// clickFlagMarker
			/**
			 * @Des 右击 旗帜
			 * @Auth
			 * @Date
			 */
			rightClickFlag(e) {
				return false;
				e = e || event;
				let extData = e.target.getExtData();
				
				// 空值 中止
				if (this.$checkEmpty(this.organizations[0]) || this.$checkEmpty(this.organizations[0].children)) return false;
				
				let items = [];
				let has_children_falg = false;
				this.organizations[0].children.forEach((row, index) => {
					let item = {
						label: row.label,
						icon: "el-icon-map-location",
						divided: true,
						minWidth: 0,
						onClick: () => {
							// 路由 跳转
							this.$router.replace({path: '/manager/location/monitor', query: {mapId: row.id}}, ()=>{}, ()=>{});
						},
					};
					
					// 子菜单
					let childItems = [];
					Object.assign([], row.children).forEach((r, i) => {
						if (!has_children_falg) {
							has_children_falg = true;
						}
						let childItem = {
							label: r.label,
							icon: "el-icon-location-outline",
							divided: true,
							minWidth: 0,
							onClick: () => {
								// 路由 跳转
								this.$router.replace({path: '/manager/location/monitor', query: {areaId: row.id,mapId: r.id}}, ()=>{}, ()=>{});
							},
						};
						childItems.push(childItem);
					});
					if (childItems.length > 0) {
						item.children = Object.assign([], childItems);
						delete item['onClick'];
					}
					items.push(item);
				});
				
				this.$contextmenu({
					items: items,
					// event, event.clientX event.clientY
					x: event.clientX,
					y: event.clientY,
					customClass: ("context-menu-flag"+ (!has_children_falg?' none-children':'')),
					zIndex: 3,
					minWidth: 50,
				});
			},// rightClickFlag
			
			//执行搜索
			handleSearch(){
				// 地图未加载完成 跳过
				if (!this.flags.falg_AMap_inited) return false;
				
				// 空值 中止
				if (this.$checkEmpty(this.filters.address)) {
					// 地理位置 清除 marker
					this.autocomplete.clearPlace();
					return false;
				}
				
				// 地理编码
				this.mapFn.geoCode(this.filters.address, (status, result) => {
					if (status === 'complete'&&result.geocodes.length) {
						let geocode = Object.assign({}, result.geocodes[0]);
						let adcode = geocode.adcode || '';
						
						// 地理位置 自动搜索
						this.autocomplete.setPlace(adcode, this.filters.address);
					}else{
						console.log('根据地址查询位置失败', status, result);
					}
				});
			},// handleSearch
			
			/**
			 * @Des 绘制 图元
			 * @Auth
			 * @Date
			 */
			// 绘制 图元
			drawMarker(info) {
				// 创建 marker
				let marker = this.mapFn.creatMarker({
					label: {
						content: info.projectName || '新增项目',
						// content:'手牵手',
						direction: "top",
						offset: [-10, 0],
					},
					offset: [0, -14],
					position: [parseFloat(info.centerLng), parseFloat(info.centerLat)],
					icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",// !this.$checkEmpty(info.alarms) ? "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png" : "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
					extData: {"markerID": info.projectId, "markerItem": info},
					
				});
				// marker.content = this.initMarkerContent(info);
				
				// 添加 marker
				this.mapFn.addMarker(info.projectId, marker);
				
			},// drawMarker
			/**
			 * @Des 移除 图元
			 * @Auth
			 * @Date
			 */
			removeMarker(did) {
				// 添加 marker
				this.mapFn.removeMarker(did);
			},// removeMarker
			
			/**
			 * @Des 绘制 图元
			 * @Auth
			 * @Date
			 */
			drawDragMarker(info) {
				// 创建 marker
				let marker = this.mapFn.creatMarker({
					label: {
						content: info.projectName,// || info.did.substring(info.did.length - 4),
						// content:'手牵手',
						direction: "top",
						offset: [-10, 0],
					},
					offset: [0, 0],
					draggable: true,
					position: [parseFloat(info.centerLng), parseFloat(info.centerLat)],
					icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",// !this.$checkEmpty(info.alarms) ? "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png" : "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
					extData: {"markerID": info.projectId, "markerItem": info},
					
				});
				// marker.content = this.initMarkerContent(info);
				
				// 添加 marker
				this.mapFn.addMarker(info.projectId, marker);
				
			},// drawMarker
			/**
			 * @Des 移除 图元
			 * @Auth
			 * @Date
			 */
			removeDragMarker(did) {
				// 添加 marker
				this.mapFn.removeMarker(did);
			},// removeMarker
			
			// ========================================= 点聚合 start ========================================= //
			/**
			 * @Des 初始化 点聚合
			 * @Auth
			 * @Date
			 */
			initMarkerCluster() {
				// 地图未加载完成 跳过
				if (!this.flags.falg_AMap_inited) return false;
				// 移除 点聚合marker
				this.removeAllClusterMarkers();
				
				let markers = [];
				Object.assign([], this.rows).forEach((row, index) => {
					// 创建 marker
					let marker = this.mapFn.creatMarker({
						label: {
							content: row.projectName,// || row.did.substring(row.did.length - 4),
							direction: "top",
							offset: [-10, 0],
						},
						// offset: [0, -14],
						position: [parseFloat(row.centerLng), parseFloat(row.centerLat)],
						offset: [28, 0], // 将红旗位置上移一些，使其正好位于覆盖物左上角
						size: [60, 60],
						imageSize: [60, 60],
						icon: '/static/images/map/outdoorIocns/iocn-flag.webp',
						// icon: !this.$checkEmpty(row.alarms) ? "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png" : "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
						extData: {"markerID": row.projectId, "markerItem": row},
					});
					marker.content = this.initMarkerContent(row);
					
					markers.push(marker);
				});
				
				// 点聚合
				!this.$checkEmpty(markers) && this.mapFn.creatMarkerCluster(Object.assign([], markers));
			},// initMarkerCluster
			/**
			 * @Des 添加 点聚合marker
			 * @Auth
			 * @Date
			 */
			addClusterMarker(info) {
				// 地图未加载完成 跳过
				if (!this.flags.falg_AMap_inited) return false;
				// 空值 中止
				if (this.$checkEmpty(info) || this.$checkEmpty(info.projectId)) return false;
				
				// 创建 marker
				let marker = this.mapFn.creatMarker({
					label: {
						content: info.projectName,// || info.did.substring(info.did.length - 4),
						direction: "top",
						offset: [-10, 0],
					},
					// offset: [0, 0],
					position: [info.centerLng, info.centerLat],
					offset: [28, 0], // 将红旗位置上移一些，使其正好位于覆盖物左上角
					size: [60, 60],
					imageSize: [60, 60],
					icon: '/static/images/map/outdoorIocns/iocn-flag.webp',
					// icon: !this.$checkEmpty(info.alarms) ? "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png" : "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
					extData: {"markerID": info.projectId, "markerItem": Object.assign({}, info)},
				});
				marker.content = this.initMarkerContent(info);
				
				// 点集合 添加 marker
				this.mapFn.addClusterMarker(marker);
			},// addClusterMarker
			/**
			 * @Des 移除 点聚合marker
			 * @Auth
			 * @Date
			 */
			removeClusterMarker(did) {
				// 地图未加载完成 跳过
				if (!this.flags.falg_AMap_inited) return false;
				// 空值 中止
				if (this.$checkEmpty(did)) return false;
				// 点集合 移除 marker
				this.mapFn.removeClusterMarker(did);
			},// removeClusterMarker
			/**
			 * @Des 更新 点聚合marker
			 * @Auth
			 * @Date
			 */
			updateClusterMarker(info) {
				// 地图未加载完成 跳过
				if (!this.flags.falg_AMap_inited) return false;
				// 空值 中止
				if (this.$checkEmpty(info) || this.$checkEmpty(info.projectId)) return false;
				// 点集合 移除 marker
				this.removeClusterMarker(info.projectId);
				// 点集合 移除 marker
				this.addClusterMarker(info);
			},// updateClusterMarker
			/**
			 * @Des 移除 点聚合marker
			 * @Auth
			 * @Date
			 */
			removeAllClusterMarkers() {
				// 地图未加载完成 跳过
				if (!this.flags.falg_AMap_inited) return false;
				
				// 点集合 移除 markers
				this.mapFn.removeClusterMarkers();
				return false;
				// 移除 原marker
                Object.assign([], this.keys).forEach((did) => {
                	// 点集合 移除 marker
                	this.mapFn.removeClusterMarker(did);
                });
			},// removeAllClusterMarkers
			
			// ========================================= 点聚合 end ========================================= //
			
			/**
			 * @Des 图元 content
			 * @Auth
			 * @Date
			 */
			initMarkerContent(item) {
				let itemStr = JSON.stringify(item).replace(/\"/g,"'");
				let _content = `
		       <div class="map-info-content-box" style="background-color: #fff;font-size: small;border-radius: 10px;opacity: 0.9;padding: 10px;box-shadow: 0px 0px 20px 0px rgba(0,0,0,1);">
		       <div style="text-align: center;"><h3 style="font-weight: bold;color: #000;">` + (item.projectName || '') + `</h3></div>
		       <div className="custom-infowindow input-card" style="z-index:999999999999;text-align: left;">
		       <label style="color:#000000">中心经度:<span style='color: #2700ff'>` + item.centerLng +` </span></label></p>
		       <label style="color:#000000">中心纬度:<span style='color: #2700ff'>` + item.centerLat + `</span></label></p>
		       <label style="color:#000000">坐标系:<span style='color: #2700ff'>` + this.coordinateTypes[item.coordinate] + `</span></label></p>
		       <label class="text-over" style="display: block;color:#000000;max-width: 380px;">地址:<span style='color: #2700ff;' title="` + (item.website || ``) + `">` + (item.website || `----`) + ` </span></label></p>
		       <label style="color:#000000">创建时间:<span style='color: #2700ff'>` + (this.$moment(item.createTime)).format('YYYY-MM-DD HH:mm:ss') + `</span></label></p>
		       </div>
		       <div style="text-align: center;padding-top: 5px;">
		       <button type="button" class="button-custom-1" onclick="goToHere('` + [parseFloat(item.centerLng), parseFloat(item.centerLat)] + `','` + item.projectId + `')">
		       <i class="el-icon-position"></i>
		       <span>到这</span>
		       </button>
		       <button type="button" class="button-custom-1" onclick="updateRow(` + itemStr + `)">
		       <i class="el-icon-edit"></i>
		       <span>编辑</span>
		       </button>
		       <button type="button" class="button-custom-1" onclick="deleteRow(` + itemStr + `)">
		       <i class="el-icon-delete"></i>
		       <span>删除</span>
		       </button>
		       `+ (item.website ? `<button type="button" class="button-custom-1" onclick="gotoLocation(` + itemStr + `)">
		       <i class="el-icon-link"></i>
		       <span>访问本地</span>
		       </button>` : ``) +`
		       </div>
		       </div>
		        `;
				return _content;
			},
			
			/**
			 * @Des 到这
			 * @Auth
			 * @Date
			 */
			goToHere(lnglat, did) {
				// 地图未加载完成 跳过
				if (!this.flags.falg_AMap_inited) return false;
				
				this.mapFn.setZoomAndCenter(18, lnglat.split(','));
				this.mapFn.setZoom(20);
			},// goToHere
			/**
			 * @Des 访问本地
			 * @Auth
			 * @Date
			 */
			gotoLocation(row) {
				// 空值 中止
				if (this.$checkEmpty(row) || this.$checkEmpty(row.website)) return false;
				window.open(row.website);
			},// gotoLocation
			
			// 列表 到这
			handleToHere(index, item) {
				// 地图未加载完成 跳过
				if (!this.flags.falg_AMap_inited) return false;
				
				let infoContent = this.initMarkerContent(item);
				// 打开 信息窗体
				this.mapFn.updateInfoWindow(item.projectId, infoContent);
				// 打开 信息窗体
				this.mapFn.openInfoWindow([item.centerLng, item.centerLat]);
				
				this.mapFn.setZoomAndCenter(10, [item.centerLng, item.centerLat]);
				this.mapFn.setZoom(12);
				
				// 更新 点聚合marker
				// this.updateClusterMarker(item);
			},// handleToHere
			// 跳转 设备历史轨迹
			handleTrack(index, item) {
				let did = item.did;
				let createTime = item.createTime;
				// 路由 跳转
				// this.$router.replace({path: '/manager/history/device-record', params: {did: did, createTime: createTime, tab: 'track'}}, ()=>{}, ()=>{});
				this.$router.push({name: 'device-record', params: {did: did, createTime: createTime, tab: 'track'}});
			},// handleTrack
			// 点击 行
			handleRowClick(row, column){
				if (column.label == '操作') return false;
				
				// 地图未加载完成 跳过
				if (!this.flags.falg_AMap_inited) return false;
				
				let infoContent = this.initMarkerContent(row);
				// 打开 信息窗体
				this.mapFn.updateInfoWindow(row.projectId, infoContent);
				// 打开 信息窗体
				this.mapFn.openInfoWindow([row.centerLng, row.centerLat]);
				
				this.mapFn.setZoomAndCenter(10, [row.centerLng, row.centerLat]);
				this.mapFn.setZoom(12);
			},// handleRowClick
			
			// 显示/隐藏 右侧列表
			changeAsideFlag() {
				this.showAsideFlag = !this.showAsideFlag;
			},
			// 关键字变化
			filterChange() {
				
			},// filterChange
			
			/**
             * @Des 重新搜索 项目
             * @Auth
             * @Date 
             */
			researchProjects() {
				// 交互锁
				if (this.lock) return false;
				
				this.pagination.total = 0;
				this.pagination.startNum = 0;
				this.pagination.currentPage = 1;
				
				// 交互锁
				this.lock = true;
				this.searchProjects();
			},// researchProjects
			/**
             * @Des 查询 项目
             * @Auth
             * @Date 
             */
			searchProjects() {
				
				// 移除 点聚合marker
				this.removeAllClusterMarkers();
				
				// 交互 参数
				let formData = {
					// projectId: this.$store.state.currentProjectId,
					total: this.pagination.total,
					startNum: this.pagination.startNum,
					limit: this.pagination.limit,
				};
				// 交互
				this.$request.postJsonRequest(ApiOrgGnss.searchProjectApi, formData).then(result => {
					// 交互锁
					this.lock = false;
					
                    let keys = [];
                    let rows = [];
                    Object.assign([], result.data).forEach((row, index) => {
                    	
                    	let i = keys.indexOf(row.projectId);
                    	if (i == -1) {
                    		// key list
                    		keys.push(row.projectId);
                    		// 数据 列表
                    		rows.push(Object.assign({}, row, {index: index}));
                    	} else {
                    		this.$set(rows, i, Object.assign({}, row, {index: i}));
                    	}
                    });
                    
                    // 更新数据
                    this.keys = Object.assign([], keys);
                    this.rows = Object.assign([], rows);
                    
                    // 初始化 点聚合
					this.initMarkerCluster();
                    
                }).catch(error => {
                	// 交互锁
					this.lock = false;
                    console.error('查询项目异常', ApiOrgGnss.searchGpsTagApi);
                });
			},// searchProjects
			
			/**
             * @Des 新增 项目
             * @Auth
             * @Date 
             */
			addRow() {
				// 取消
				this.cancel();
				
				// flags
				this.flags.flag_row_add = true;
				// 关闭 信息窗体
				this.mapFn.closeInfoWindow();
				
				this.mapFn.bindMouseEvent({
					mousemoveEventFlag: false,
					mousemoveCallBack: (e) => {
						console.log('mousemoveCallBack', e);
					},
					clickEventFlag: true,
					clickCallBack: (e) => {
						this.lnglat = {lat: e.lnglat.lat, lng: e.lnglat.lng};
						this.removeMarker('projectId_add');
						this.drawMarker({
							projectId: 'projectId_add',
							projectName: '新增项目',
							centerLng: e.lnglat.lng,
							centerLat: e.lnglat.lat,
						});
						
						this.$nextTick(() => {
							this.$refs.OrgDialog.openDialog(false);
						});
					},
				});
			},// addRow
			/**
             * @Des 编辑 项目
             * @Auth
             * @Date 
             */
            updateRow(row) {
            	// 空值 中止
				if (this.$checkEmpty(row) || this.$checkEmpty(row.projectId)) return false;
				// 取消
				this.cancel();
				
				// flags
				this.flags.flag_row_edit = true;
				this.lnglat = {lat: row.centerLat, lng: row.centerLng};
				this.rowInfo = Object.assign({}, row);
				// 关闭 信息窗体
				this.mapFn.closeInfoWindow();
				
				// 移除 点聚合marker
				this.removeClusterMarker(row.projectId);
				this.drawMarker({
					projectId: 'projectId_edit',
					projectName: '编辑项目',
					centerLng: row.centerLng,
					centerLat: row.centerLat,
				});
				
				this.mapFn.bindMouseEvent({
					mousemoveEventFlag: false,
					mousemoveCallBack: (e) => {
						console.log('mousemoveCallBack', e);
					},
					clickEventFlag: true,
					clickCallBack: (e) => {
						this.lnglat = {lat: e.lnglat.lat, lng: e.lnglat.lng};
						
						this.removeMarker('projectId_add');
						this.removeMarker('projectId_edit');
						this.drawMarker({
							projectId: 'projectId_edit',
							projectName: '编辑项目',
							centerLng: e.lnglat.lng,
							centerLat: e.lnglat.lat,
						});
						
						this.$nextTick(() => {
							this.$refs.OrgDialog.openDialog(true, Object.assign({}, row, {centerLng: e.lnglat.lng, centerLat: e.lnglat.lat}), row.index);
						});
					},
				});
            },// updateRow
            
			/**
             * @Des 删除 项目
             * @Auth
             * @Date 
             */
			deleteRow(row) {
				// 交互锁
				if (this.locked_delete) return false;
				
				// 空值 中止
				if (this.$checkEmpty(row) || this.$checkEmpty(row.projectId)) return false;
				
				this.$confirm('确认删除项目【' + row.projectName + '】吗？', '询问', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					closeOnClickModal: false,
					type: 'warning'
				}
				).then(_ => {
					//console.log('confirm');
					// 交互 删除
					this.requestDeleteRow(row);
				}).catch(_ => {
					//console.log('cancel')
				});
			},// deleteRow
			/**
             * @Des 交互 删除
             * @Auth
             * @Date 
             */
            requestDeleteRow(row) {
            	// 交互锁
            	this.locked_delete = true;
				
            	this.$request.postJsonRequest(ApiOrgGnss.deleteProjectApi, {
					projectId: row.projectId
				}).then(result => {
					// 交互锁
					this.locked_delete = false;
					
					// console.log(result); return false;
					if(result.code == 0) {
						// 添加成功
						this.cancel();
						// 关闭 信息窗体
						this.mapFn.closeInfoWindow();
						
						this.$message({
							message: '项目删除成功！',
							type: 'success',
							showClose: true,
							dangerouslyUseHTMLString: true,
							onClose: (() => {
								// 重新搜索 项目
								this.researchProjects();
							})
						});
					} else {
						this.$message({
							message: result.msg,
							type: 'error',
							showClose: true,
							dangerouslyUseHTMLString: true
						});
					}
				}).catch(error => {
					// 交互锁
					this.locked_delete = false;
					console.error('删除项目异常', ApiOrgGnss.updatePwdApi, error);
				})
            },// requestDeleteRow
			
			/**
             * @Des 完成取点
             * @Auth
             * @Date 
             */
			completePoint() {
				// flags
				if (this.flags.flag_row_edit) {
					this.$nextTick(() => {
						this.$refs.OrgDialog.openDialog(true, Object.assign({}, this.rowInfo, {centerLng: this.lnglat.lng, centerLat: this.lnglat.lat}), this.rowInfo.index);
					});
					return false;
				}
				this.$nextTick(() => {
					this.$refs.OrgDialog.openDialog(false);
				});
			},// completePoint
			/**
             * @Des 取消
             * @Auth
             * @Date 
             */
			cancel() {
				// flags
				this.flags.flag_row_add = false;
				this.flags.flag_row_edit = false;
				
				this.removeMarker('projectId_add');
				this.removeMarker('projectId_edit');
				
				// 经纬度
				this.lnglat = Object.assign({}, {lat: '', lng: ''});
				
				// 更新 点聚合marker
				this.updateClusterMarker(Object.assign({}, this.rowInfo));
				this.rowInfo = Object.assign({}, {});
				
				this.mapFn.offMouseEvent();
			},// cancel
			
			/**
			 * @Des 改变总数
			 * @Auth
			 * @Date 
			 */
			setTotal(val) {
				this.pagination.total = val;
				if(val == 0) {
					this.pagination.currentPage = 1;
					this.pagination.startNum = 0;
				}
				// 查询list
				this.searchProjects();
			},// setTotal
			/**
			 * @Des 更新列表
			 * @Auth
			 * @Date 
			 */
			setRow(row, index) {
				//console.log(row, index);return false;
				// this.rows[index] = Object.assign({}, row);
				this.$set(this.rows, index, Object.assign({}, row));
				
				// 更新 点聚合marker
				this.updateClusterMarker(Object.assign({}, row));
			},// setRow
			
			/**
			 * @Des 当前页数据改变
			 * @Auth
			 * @Date 
			 */
			handleCurrentChangeSub(val) {
				this.pagination.currentPage = val;
				this.pagination.startNum = this.pagination.limit * (val - 1);
			},// handleCurrentChangeSub
			/**
			 * @Des 页长度改变
			 * @Auth
			 * @Date 
			 */
			handleSizeChangeSub(val) {
				this.pagination.limit = val;
				this.pagination.currentPage = 1;
				this.pagination.startNum = 0;
			},// handleSizeChangeSub
			
			/**
			 * @Des 改变排序
			 * @Auth
			 * @Date 
			 */
			changeSort(data) {
				let prop = data.prop;
				let order = data.order;
				if(order == null) {
					order = this.filters.orderBy[prop];
				} else {
					order = order.replace("ending", "");
				}
				if(order != null) {
					this.filters.orderBy = {};
					this.filters.orderBy[prop] = order;
				}
				this.researchProjects();
			},// changeSort
			
		},// methods
		
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			pagination: {
				handler(newVal, oldVal) {
					this.searchProjects();
				},
				immediate: false,
				deep: true,
			},// pagination
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
		
    }// export default
</script>

/* CSS */
<style lang="scss" scoped>
	
	/* 表单 地图 */
	/deep/ .form-out-map {
		position: absolute;
		top: 10px;
		right: 10px;
		
		.el-form-item {
			margin: 0;
		}
		
		.el-input .el-input__clear {
			line-height: 30px;
			background-color: #061b3d;
		}
		
		/* 输入框 */
		.el-input__inner {
			height: 30px;
			font-size: 14px;
			padding-left: 5px;
			padding-right: 5px;
		}/* el-input__inner */
		
		.el-input-group__append,
		.el-input-group__prepend {
			padding: 0 10px;
			
			button.el-button {
				padding: 0 10px;
				margin: -10px -10px;
			}/* button.el-button */
			
		}/* group__append group__prepend */
		
	}/* form-out-map */
	
	.el-button--success {
		background-color: #67C23A;
		border-color: #67C23A;
	}
	.el-button--primary {
		background-color: #409EFF;
		border-color: #409EFF;
	}
	.el-button--info {
		background-color: #909399;
		border-color: #909399;
	}
	.el-button--danger {
		background-color: #F56C6C;
		border-color: #F56C6C;
	}
	
	.aside-button-box {
		width: 70px;
		height: 40px;
		
		position: absolute;
		bottom: 0;
		margin: auto;
		
		&.b-0 {left: calc(50% - 20px); bottom: 0;}
		&.b-30 {left: calc(50% - 20px); bottom: calc(40% - 20px);}
	}/* aside-button-box */
	/deep/ .beautifyTableClass {
		height: 100%;
		
		.el-table {
			height: 100%;
		}
		.el-table__body-wrapper {
			overflow-y: auto;
		}
		.el-table th>.cell {
			height: 40px;
			line-height: 40px;
		}
		.el-input__inner {
			height: 35px;
			border-color: #ccc;
			background-color: #fff;
			color: #000;
		}
		.el-table__empty-block {
			background-color: #eee;
			color: #ccc;
		}
		.el-button {
			border-image: none;
			box-shadow: none;
		}
	}/* beautifyTableClass */
	
	.area-items-box, .map-items-box {
		ul {
			background-color: #034178;
			/*border-image: linear-gradient(90deg, #0A9AFB, #0A9AFB, #0A9AFB) 1 1;*/
			
			li {
				width: auto;
				min-width: max-content;
				max-width: 200px;
				background-color: #061b3d;
				color: #e9eaeb;
				&:hover {
					border-color: #4681bf;
				}
			}
			
		}/* ul */
	}/* area-items-box map-items-box */
	
</style>
<!--<style lang="scss" src="@/static_dazzle/css/amap/amap.scss"></style>-->

/* CSS */
<style lang="scss" >
	/* 右键菜单 旗帜 */
	.context-menu-flag {
		.menu_item {
			padding-right: 20px !important;
		}
		
		&.none-children {
			.menu_item_expand_icon {
				display: none;
			}
		}
	}/* context-menu-flag */
</style>



// WEBPACK FOOTER //
// src/components_outdoor/Organization/OrgModule.vue